interface VenueType {
  title: string;
  address: string;
}

// Type definitions for the pilot assignment object
export interface PilotAssignment {
  id: number;
  title: string;
  description: string;
  date: string;
  time: string;
  callTime: string;
  venue: VenueType;
  notes: string;
  role: string;
  payout: number;
}

// Type definitions for the pilot performance report object
export interface PilotPerformance {
  id: number;
  month: string;
  totalAssignments: number;
}

// Array of dummy pilot assignments
export const pilotAssignments: PilotAssignment[] = [
  {
    id: 1,
    title: "Goretzka Memorial",
    description: "Celebration of Life",
    date: "2025-12-13",
    time: "12:30",
    callTime: "11:30",
    venue: {
      title: "OMFS",
      address: "8 Baines Ave. Avenues, Harare"
    },
    role: "Photographer",
    payout: 50,
    notes: "Capture dignified and respectful moments throughout the memorial service. Focus on candid shots of family members, the venue setup, and meaningful interactions while maintaining sensitivity to the somber occasion. Deliver edited high-resolution images within 5 business days."
  },
  {
    id: 2,
    title: "Moyo Wedding",
    description: "Traditional Wedding Ceremony",
    date: "2025-11-28",
    time: "14:00",
    callTime: "12:00",
    venue: {
      title: "The Venue Country Hotel",
      address: "157 Borrowdale Rd, Borrowdale, Harare"
    },
    role: "Photographer",
    payout: 150,
    notes: "Document all key moments of the traditional ceremony including the bride's entrance, exchange of vows, cultural rituals, and family portraits. Coordinate with the videographer to ensure comprehensive coverage without obstruction. Provide a curated collection of 300+ edited photos highlighting the couple's special day within two weeks."
  },
  {
    id: 3,
    title: "TechZim Conference 2024",
    description: "Tech Innovation Summit",
    date: "2025-08-24",
    time: "09:00",
    callTime: "07:30",
    venue: {
      title: "Rainbow Towers",
      address: "54-56 Park Lane, Harare"
    },
    role: "Producer",
    payout: 200,
    notes: "Oversee all technical and logistical aspects of the conference including stage management, speaker coordination, and audio-visual production. Ensure smooth transitions between sessions, manage the run-of-show timeline, and troubleshoot any technical issues. Coordinate with venue staff, AV team, and speakers to deliver a professional multi-session event."
  },
  {
    id: 4,
    title: "Chikwanha Baby Shower",
    description: "Celebrating New Beginnings",
    date: "2025-07-18",
    time: "15:30",
    callTime: "13:30",
    venue: {
      title: "Private Residence",
      address: "23 Churchill Rd, Highlands, Harare"
    },
    role: "Videographer",
    payout: 80,
    notes: "Create a warm and engaging video capturing the joy and celebration of the baby shower. Film key moments including games, gift opening, guest interactions, and heartfelt messages for the parents-to-be. Deliver a 5-7 minute highlight reel with background music and a full-length raw footage backup within one week."
  },
  {
    id: 5,
    title: "Corporate Gala Dinner",
    description: "Econet Awards Night",
    date: "2025-07-10",
    time: "18:00",
    callTime: "16:30",
    venue: {
      title: "Meikles Hotel",
      address: "Corner Third St & Jason Moyo Ave, Harare"
    },
    role: "Tribute Table",
    payout: 250,
    notes: "Curate and manage an elegant tribute display showcasing the achievements and honorees of the evening. Design the table layout to complement the gala's theme, incorporate branded elements, and ensure visual appeal for photo opportunities. Coordinate with the events team to align the tribute presentation with the program schedule and maintain the display throughout the evening."
  },
  {
    id: 6,
    title: "Ndlovu Graduation Party",
    description: "Graduation Celebration",
    date: "2025-06-29",
    time: "16:00",
    callTime: "13:30",
    venue: {
      title: "The Woods Resort",
      address: "Norton Rd, Norton, Mashonaland West"
    },
    role: "Sound Engineer",
    payout: 120,
    notes: "Set up and operate all audio equipment to ensure clear sound quality throughout the celebration. Manage microphones for speeches and toasts, control background music levels during dinner and dancing, and provide technical support for any audio-visual presentations. Conduct sound checks prior to the event and remain on-site to adjust levels and troubleshoot any issues."
  },
]

// Array of dummy pilot perfomance reports
export const pilotMonthlyPerfomance: PilotPerformance[] = [
  {
    id: 1,
    month: "October",
    totalAssignments: 5,
  },
  {
    id: 2,
    month: "September",
    totalAssignments: 4,
  },
  {
    id: 3,
    month: "August",
    totalAssignments: 3,
  },
  {
    id: 4,
    month: "July",
    totalAssignments: 5,
  },
  {
    id: 5,
    month: "June",
    totalAssignments: 2,
  },
  {
    id: 6,
    month: "May",
    totalAssignments: 2,
  },
  {
    id: 7,
    month: "April",
    totalAssignments: 4,
  },
  {
    id: 8,
    month: "March",
    totalAssignments: 1,
  },
  {
    id: 9,
    month: "February",
    totalAssignments: 4,
  },
  {
    id: 10,
    month: "January",
    totalAssignments: 4,
  },
  {
    id: 11,
    month: "December",
    totalAssignments: 2,
  },
  {
    id: 12,
    month: "November",
    totalAssignments: 1,
  }
]
